const widthById: Record<string, number> = {
    project_name: 240,
    status: 150,
    created_by: 230,
    updated_at: 145,
    simulation_period: 210,
    scope: 240,
    action: 80,
};

export const getColumnWidth = (columnId?: string) => widthById[columnId || ''] || 180;
